module.exports = __webpack_public_path__ + "media/images/result_sets/circles/4n3n1r2r-ff3b217ae465e0842e858b7a2c2c22f0.svg";